
// eslint-disable-next-line import/extensions
import { createNamespacedHelpers } from 'vuex';
import routeMixin from '~/mixins/routeMixin';
import respUtility from '~/mixins/respUtility';

const { mapState, mapMutations } = createNamespacedHelpers('listing');

export default {
  name: 'ListingFilters',
  mixins: [routeMixin, respUtility],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Object,
      default() {
        return {};
      },
    },
    filtersFromRoute: {
      type: Object,
    },
    searchParams: {
      type: Object,
      default() {
        return {};
      },
    },
    attrs: {
      type: Object,
      default() {
        return {};
      },
    },
    resultItemsCount: {
      type: Number,
      default: 0,
    },
    desktopFiltersVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sortPanel: [],
      sortVariants: [
        { text: 'Recommended', value: 'RELEVANCE' },
        { text: 'Price: Low to High', value: 'PRICE_FROM_LOW' },
        { text: 'Price: High to Low', value: 'PRICE_FROM_HIGHT' },
        { text: 'Newest First', value: 'NEW' },
        { text: 'Top Rated', value: 'TOP_RATED' },
      ],
    };
  },
  computed: {
    ...mapState(['currentSelected', 'currentSort']),
    defaultSort() {
      return this.$store.getters['listing/defaultParams'].sortBy;
    },
    selectSort() {
      const value = this.currentSort || this.$store.getters['listing/defaultParams']?.sortBy;
      return this.sortVariants.find((v) => v.value === value) || this.sortVariants[0];
    },
    filtersLoading() {
      return Boolean(this.loading.filters || this.loading.price);
    },
    isChangedSort() {
      const oldSort = this.searchParams.sortBy;
      if (!oldSort && this.selectSort.value !== this.defaultSort) {
        return true;
      }
      return Boolean(oldSort && oldSort !== this.selectSort.value);
    },
    isClearBtn() {
      return this.selectSort.value !== this.defaultSort || this.currentSelected.customPrice
        || (this.currentSelected.selected && Object.keys(this.currentSelected.selected).length);
    },
    isShowEnabled() {
      if (this.filtersLoading || !(this.$device.isMobileOrTablet || this.isTouchDevice)) {
        return false;
      }
      if (!this.count) {
        return false;
      }
      if (this.isChangedSort) {
        return true;
      }
      return this.checkFiltersSelectedChanged(this.currentSelected, this.filtersFromRoute);
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
  },
  watch: {
    '$vuetify.breakpoint.mdAndDown': function closeMenu() {
      if (this.active) {
        this.onClose();
      }
    },
  },
  methods: {
    ...mapMutations([
      'setCurrentSort',
      'setCurrentSelected',
      'resetCurrentSelected',
    ]),
    changeSort(select) {
      if (select.value === this.selectSort.value) {
        return;
      }
      this.setCurrentSort(select.value);
    },
    showResults() {
      this.changeRouteFacets(this.currentSelected);
      this.$emit('close');
      this.sortPanel = [];
    },
    onClose() {
      this.$emit('close');
      this.setCurrentSelected(this.filtersFromRoute || {
        selected: {},
        customPrice: null,
      });
      this.setCurrentSort(this.searchParams.sortBy || this.defaultSort);
      this.sortPanel = [];
      if (!this.$isSpider && (this.$device.isMobileOrTablet || this.isTouchDevice)
        && document.getElementById('merchantwidget-iframe-wrapper')) {
        document.getElementById('merchantwidget-iframe-wrapper').style.display = 'block';
      }
    },
    onClear() {
      this.resetCurrentSelected();
    },
    toggleDesktopFilters() {
      this.$emit('toggle-desktop-filters');
    },
  },
};
